import { el } from './dom';

/**
 * Renders what the user was understood to have said — textContent only,
 * never innerHTML. Shown ahead of the assistant's own response so the
 * exchange reads as a conversation, not just an answer with no visible
 * question.
 */
export function renderTranscript(container: HTMLElement, transcript: string): void {
  container.append(el({ tag: 'p', className: 'kia-transcript', text: transcript }));
}
